// $(window).click(function() {
//     //Hide the menus if visible
//     $(".mainMenu").removeClass("open");
// });



// $( "#hamburger" ).click(function() {
//     $(".mainMenu").addClass("open");
// });

$( ".mainMenu__close" ).click(function() {
    $(".mainMenu").removeClass("open");
});


$( "#languageSelector" ).click(function() {
    $("#languageMenu").toggleClass("open");
});


//The good thing about this solution is it doesn't stop event propagation.

var clickFlag = 0;
$('body').on('click', function () {
    if(clickFlag == 0) {
        // console.log('hide element here');
        /* Hide element here */
        $(".mainMenu").removeClass("open");
        // $("#languageMenu").removeClass("open");
    }
    else {
        clickFlag=0;
    }
});

$('body').on('click','#hamburger', function (event) {
    clickFlag = 1;
    // console.log('showed the element');
    /* Show the element */
    $(".mainMenu").addClass("open");
    $("#languageMenu").removeClass("open");
});
